import HttpClient from "../../../core/HttpClient";
import Failure from "../../../core/Failure";
import { Authentication } from '@leedpulse-monorepo/classes';
import * as XLSX from 'xlsx';

async function exportNotifications(auth: Authentication, subscriptionId: string) {
    try {
        const response = await HttpClient.post(
            '/notifications/export',
            {
                export: true
            },
            auth.token,
            false,
            {
                'x-subscription-id': subscriptionId,
            }
        );

        if (response.success && response.statusReponse === 'OK') {
            // Create a new workbook
            const wb = XLSX.utils.book_new();
            // Add the worksheet to the workbook
            XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(response.data), 'notifications');
            // Save the workbook
            XLSX.writeFile(wb, 'Export-Notifications-' + subscriptionId + '-' + new Date().getTime() + '.xlsx');

            return {
                success: true,
                message: 'Les notifications ont bien été exportées.',
            };
        } else {
            return {
                success: false,
                message: 'Une erreur est survenue lors de l\'export des notifications. Veuillez réessayer ultérieurement.',
            };
        }
    } catch (error) {
        return {
            success: false,
            message: 'Une erreur est survenue lors de l\'export des notifications. Veuillez réessayer ultérieurement.',
        };
    }
}

export class ExportNotificationsFailure extends Failure {
    constructor(message = 'Unknown error', code = 'unknown-error') {
        super(message, code);
    }
}

export default exportNotifications;